import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '../../../components/Button';
import img from '../../../assets/your-say.svg';
import backgroundImg from '../../../assets/background-circles.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: '10rem 1.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundImage: `url(${backgroundImg})`,
    [theme.breakpoints.down('sm')]: {
      padding: '10rem 1rem',
    },
  },
  title: {
    padding: '0',
    width: '100%',
    textAlign: 'left',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem',
    },
  },
  text: {
    width: '100%',
    textAlign: 'left',
    lineHeight: '2rem',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem',
    },
  },
  button: {
    marginTop: '2rem',
    padding: '1rem 2rem',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '1rem',
    },
  },
  imgContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'center',
    marginBottom: '4rem',
  },
  img: {
    width: '25rem',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
}));

const ReviewsSection = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container maxWidth="lg" fixed disableGutters>
        <Grid container spacing={0}>
          <Grid item md={7} sm={12}>
            <div className={classes.imgContainer}>
              <img src={img} alt="reviews" className={classes.img} />
            </div>
          </Grid>
          <Grid item md={5} sm={12}>
            <Typography variant="h1" color="primary" className={classes.title}>
              Are you a person with a disability or a carer?
            </Typography>
            <Typography variant="h3" className={classes.text}>
              Hold services accountable, celebrate the great work that they do and be included in the conversation.
            </Typography>
            <Typography variant="h3" color="primary" className={classes.text}>
              <b>Have your voice heard!</b>
            </Typography>
            <Typography variant="h3" className={classes.text}>
              Help improve disability services and guide your peers by writing a review for others to read.
            </Typography>
            <Button
              label="Share your experience"
              to="/review"
              variant="outlined"
              className={classes.button}
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default ReviewsSection;
